// Matches the custom `#{key}` delimiter previously configured via lodash.template's
// `interpolate` option. Only bare key lookups are supported (no expression evaluation)
// since that is the only form used by templates in this codebase.
const TEMPLATE_REGEX = /#{([\s\S]+?)}/g;

export function replaceValues<T>(o: T, data: object): T {
    const values = data as Record<string, unknown>;
    try {
        const json = JSON.stringify(o).replace(TEMPLATE_REGEX, (_match, key) => {
            const trimmedKey = key.trim();
            if (!(trimmedKey in values)) {
                // Matches lodash.template's behavior of throwing when a key is
                // missing from the data object, which the outer catch turns into
                // "leave the whole object unchanged".
                throw new Error(`Missing template key "${trimmedKey}"`);
            }
            const value = values[trimmedKey];
            return value === null || value === undefined ? "" : String(value);
        });
        const escaped = json.replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t");
        return JSON.parse(escaped);
    } catch (error) {
        // Let it go
        // console.error(`Template replace failed: ${error}`);
    }

    return o;
}

function getOrdinalSuffix(number: number) {
    if (number >= 11 && number <= 13) {
      return 'th';
    }
    const lastDigit = number % 10;
    switch (lastDigit) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }
  
  export function reformatDate(inputDate: string | number | Date) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    const ordinalSuffix = getOrdinalSuffix(day);
  
    return `${month} ${day}${ordinalSuffix}, ${year}`;
  }
  
  export function joinWithAnd(arr: string[]) {
    if (arr.length === 0) {
      return '';
    } else if (arr.length === 1) {
      return arr[0];
    } else if (arr.length === 2) {
      return arr.join(' and ');
    } else {
      const lastElement = arr.pop(); // Remove the last element
      const joinedString = arr.join(', ') + ', and ' + lastElement;
      return joinedString;
    }
  }

// Tests

// const data = {
//     foo: 3,
//     d: new Date().toDateString(),
//     name: "Joe Bloe",
//     a: ["x", "y", "z"]
// };

// const T = {
//     // eslint-disable-next-line no-template-curly-in-string
//     x: "${foo} ${a}"
// }

// console.log(JSON.stringify(replaceValues(T, data)));